import { useState } from "react";

const Choices = ({ choices, selectChoice }) => {
  const [selectedChoice, setSelectedChoice] = useState(null);

  const handleChoiceClick = (index) => {
    setSelectedChoice(index);
    selectChoice(choices[index]);
  }

  return (
    <div className="choices">
      { 
        choices.map((choice, index) => {
          return (
            <div
              className={'choice' + (selectedChoice === index ? ' selected' : '')} 
              key={choice.key} 
              onClick={() => handleChoiceClick(index)}
            >
              { choice.label }
            </div>
          );
        })
      }
    </div>
  )
};

export default Choices;